import { MenuListItem, MenuListItemIcon } from "@/components/ui/MenuList";
import { useIsDeveloper } from "@/hooks/useIsDeveloper";
import { useAppDispatch, useAppSelector } from "@/store";
import { toggleDeveloperMode } from "@/store/slices/user.slice";

const DeveloperModeToggle = () => {
    const isDeveloper = useIsDeveloper();
    const developerMode = useAppSelector((state) => state.user.developerMode);
    const dispatch = useAppDispatch();

    if (!isDeveloper) return null;

    return (
        <MenuListItem onClick={() => dispatch(toggleDeveloperMode())}>
            <MenuListItemIcon icon={"lely-icon-objects"} />
            Developer Mode - {developerMode ? "Disable" : "Enable"}
        </MenuListItem>
    );
};

export { DeveloperModeToggle };
